// Normalises VITE_API_URL to the licence backend's ORIGIN: the one place it is done.
//
// VITE_API_URL is a bare origin in every deployed configuration (docker-compose*.yml, ci.yml,
// deploy*.yml), but docker-compose.hosted.yml documents API_URL with a `/api/v1` example, so a base
// that already carries the prefix has to give the same answer as a bare one. Callers spell
// `/api/v1/...` out themselves (the server mounts every route there), so a base that kept the prefix
// would double it and post to a path that does not exist.
//
// A pure function with no env read and no import of lib/supabase.ts on purpose: that module creates
// a browser client and is mocked wholesale in this app's test setup, so pulling one constant from it
// into the pre-login reporter drags the mock into every suite that touches it.

/** A bare origin, or a base that already ends in /api or /api/v1 -- either way the origin, with no trailing slash. */
export function normalizeApiOrigin(raw: string | undefined | null): string {
  return (raw ?? '').replace(/\/+$/, '').replace(/\/api(\/v1)?$/, '');
}
